import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon, ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';

interface StyledTagProps {
  label: string;
  onDelete?: () => void;
  disabled?: boolean;
  showArrow?: boolean;
  isOpen?: boolean;
}

const StyledTag: React.FC<StyledTagProps> = ({
  label,
  onDelete,
  disabled = false,
  showArrow = false,
  isOpen = false
}) => {
  const color = disabled ? '#757575' : '#084D6D';
  const backgroundColor = disabled ? '#F5F5F5' : '#EFF9F9';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor,
        borderRadius: '16px',
        padding: '4px 8px',
        margin: '4px',
        cursor: 'default'
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color,
          fontSize: '0.875rem',
          fontWeight: 500,
          marginRight: (onDelete && !disabled) || showArrow ? '4px' : 0
        }}
      >
        {label}
      </Typography>
      {showArrow && !disabled && (
        <ArrowDropDownIcon
          sx={{
            fontSize: '1rem',
            color,
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease-in-out'
          }}
        />
      )}
      {onDelete && !disabled && (
        <IconButton
          size="small"
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          sx={{
            padding: '2px',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          <CloseIcon sx={{ fontSize: '1rem', color }} />
        </IconButton>
      )}
    </Box>
  );
};

export default StyledTag;
